import { createContext } from "react";

/**
 * Contexto de sesión. Vive en su propio módulo para que el proveedor sea el
 * único export del fichero de componente y el fast refresh siga funcionando.
 */
export const SessionContext = createContext(null);
